import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";

export const AddHoliday = ({ onSave, holidayData, editModalVisible }) => {
  const [selectedDate1, setSelectedDate1] = useState(holidayData ? new Date(holidayData.holiday_from) : null); 
  const [selectedDate2, setSelectedDate2] = useState(holidayData ? new Date(holidayData.holiday_to) : null); 
  const [dynamicDates, setDynamicDates] = useState([]);
  const [restrictedHoliday, setRestrictedHoliday] = useState(holidayData ? holidayData.restricted : false);
  const [description, setDescription] = useState(holidayData ? holidayData.description : "");
  const [holidayName, setHolidayName] = useState(holidayData ? holidayData.name : "");
  const [fromDateError, setFromDateError] = useState("");
  const [toDateError, setToDateError] = useState("");
  const [holidayNameError, setHolidayNameError] = useState("");
  const [editHolidayName, setEditHolidayName] = useState(""); 
  const [editSelectedDate1, setEditSelectedDate1] = useState(holidayData ? new Date(holidayData.holiday_from) : null);
  const [editSelectedDate2, setEditSelectedDate2] = useState(holidayData ? new Date(holidayData.holiday_to) : null);
  const [editDynamicDates, setEditDynamicDates] = useState([]); 
  const [editDescription, setEditDescription] = useState(""); 
  const [editHolidayNameError, setEditHolidayNameError] = useState(""); 
  const [editFromDateError, setEditFromDateError] = useState(""); 
  const [editToDateError, setEditToDateError] = useState(""); 

  const [editRestrictedHoliday, setEditRestrictedHoliday] = useState(
    holidayData ? Boolean(holidayData.is_optional) : false
  );
  
  const submitButtonRef = useRef(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const shouldShowModal = editModalVisible === 'add' || editModalVisible === 'edit';

  useEffect(() => {
    if (holidayData) {
      setEditSelectedDate1(new Date(holidayData.holiday_from));
      setEditSelectedDate2(new Date(holidayData.holiday_to));
      setEditDescription(holidayData.description);
      setEditHolidayName(holidayData.holiday_name);
      setEditRestrictedHoliday(Boolean(holidayData.is_optional)); // Convert to Boolean
      generateDynamicDatesForEditModal(new Date(holidayData.holiday_from), new Date(holidayData.holiday_to));
    } else {
      setEditSelectedDate1(null);
      setEditSelectedDate2(null);
      setEditRestrictedHoliday(false);
      setEditDescription("");
      setEditHolidayName("");
      setEditDynamicDates([]);
    }
  }, [holidayData]);

  const generateDynamicDatesForEditModal = (startDate, endDate) => {
    const dates = [];
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      dates.push({ date: new Date(currentDate), type: "full-day" }); 
      currentDate.setDate(currentDate.getDate() + 1);
    }
    setEditDynamicDates(dates);
  };

  const generateDynamicDates = (startDate, endDate, isEditModal = false) => {
    const dates = [];
    const currentDate = new Date(startDate); 
    while (currentDate <= endDate) {
      dates.push({ date: new Date(currentDate), type: "full-day" }); 
      currentDate.setDate(currentDate.getDate() + 1);
    }
    
    if (isEditModal) {
      setEditDynamicDates(dates);
    } else {
      setDynamicDates(dates);
    }
  };

  const handleRestrictedHolidayChange = (event) => {
    setRestrictedHoliday(event.target.checked);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleHolidayNameChange = (event) => {
    setHolidayName(event.target.value);
    setHolidayNameError("");
  };

  const handleEditHolidayNameChange = (event) => {
    setEditHolidayName(event.target.value);
  };

  const handleDateChange1 = (date) => {
    setSelectedDate1(date);
    setFromDateError("");
    if (date && selectedDate2) {
      generateDynamicDates(date, selectedDate2);
    }
  };
  
  const handleDateChange2 = (date) => {
    setSelectedDate2(date);
    setToDateError("");
    if (selectedDate1 && date) {
      generateDynamicDates(selectedDate1, date);
    }
  };
  
  const handleEditDateChange1 = (date) => {
    setEditSelectedDate1(date);
    setEditFromDateError("");
    if (date && editSelectedDate2) {
      generateDynamicDates(date, editSelectedDate2, true); 
    }
  };
  
  const handleEditDateChange2 = (date) => {
    setEditSelectedDate2(date);
    setEditToDateError("");
    if (editSelectedDate1 && date) {
      generateDynamicDates(editSelectedDate1, date, true); 
    }
  };
  
  const handleEditRestrictedHolidayChange = (event) => {
    setEditRestrictedHoliday(event.target.checked);
  };
  
  const handleEditDescriptionChange = (event) => {
    setEditDescription(event.target.value);
  };
  
  const handleEditTypeChange = (index, selectedOption) => {
    const updatedDates = [...editDynamicDates];
    updatedDates[index].type = selectedOption.value;
    setEditDynamicDates(updatedDates);
  };
  
  const handleTypeChange = (index, selectedOption) => {
    const updatedDates = [...dynamicDates];
    updatedDates[index].type = selectedOption.value;
    setDynamicDates(updatedDates);
  };

  const handleEditSubmit = () => {
    let isValid = true;

    if (isValid) {
      const holidaysdates = editDynamicDates.map(({ date, type }) => ({
        date: formatDate(date),
        type,
      }));
      const payload = {
        groupId: holidayData.group_id,
        locationid: holidayData.locationid,
        holidayname: editHolidayName,
        holidayfrom: formatDate(editSelectedDate1),
        holidayto: formatDate(editSelectedDate2),
        holidaydescription: editDescription,
        holidaysdates,
      };

      fetch(`${apiUrl}/holidays/update/${holidayData.group_id}`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((data) => {
          onSave();
          if (submitButtonRef.current) {
            submitButtonRef.current.click(); 
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const formatDate = (date) => {
    if (!date || !(date instanceof Date)) {
      console.error("Invalid date provided:", date);
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); 
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = () => {
    let isValid = true;
    if (!selectedDate1) {
      setFromDateError("From date is required");
      isValid = false;
    }
    if (!selectedDate2) {
      setToDateError("To date is required");
      isValid = false;
    }
    if (!holidayName) {
      setHolidayNameError("Holiday name is required");
      isValid = false;
    }
    if (selectedDate1 && selectedDate2 && selectedDate2 < selectedDate1) {
      setToDateError("To date must be greater than or equal to From date");
      isValid = false;
    }

    if (isValid) {
      const holidaysdates = dynamicDates.map(({ date, type }) => ({
        date: formatDate(date),
        type,
      }));

      const payload = {
        holidayname: holidayName,
        holidayfrom: formatDate(selectedDate1),
        holidayto: formatDate(selectedDate2),
        holidaydescription: description,
        isrestricted: restrictedHoliday,
        holidaysdates,
      };
  
      fetch(`${apiUrl}/holidays/add`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        onSave();

        if (submitButtonRef.current) {
          submitButtonRef.current.click(); 
        }

        setSelectedDate1(null);
        setSelectedDate2(null);
        setDynamicDates([]);
        setRestrictedHoliday(false);
        setDescription("");
        setHolidayName("");
        setFromDateError("");
        setToDateError("");
        setHolidayNameError("");
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  };

  return (
    <>
 <div
  id="add_holiday"
  className="modal custom-modal fade"
  tabIndex="-1"
  role="dialog"
>
  <div
    className="modal-dialog modal-lg"
    style={{
      margin: 0,
      position: "fixed",
      right: 0,
      height: "100vh",
      width: "40%",
    }}
    role="document"
  >
    <div className="modal-content h-100">
      <div className="modal-header">
        <h5 className="modal-title">Add Holiday</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        className="modal-body"
        style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
      >
        <div className="scrollable-container">
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">
              Holiday Name <span className="text-danger">*</span>
            </label>
            <div className="col-md-8">
              <input
                className="form-control"
                type="text"
                value={holidayName}
                onChange={handleHolidayNameChange}
              />
              {holidayNameError && (
                <div className="text-danger">{holidayNameError}</div>
              )}
            </div>
          </div>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">
              From <span className="text-danger">*</span>
            </label>
            <div className="col-md-8">
              <div className="cal-icon">
                <DatePicker
                  selected={selectedDate1}
                  onChange={handleDateChange1}
                  className="form-control datetimepicker"
                  type="date"
                  dateFormat="dd-MM-yyyy"
                />
              </div>
              {fromDateError && (
                <div className="text-danger">{fromDateError}</div>
              )}
            </div>
          </div>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">
              To <span className="text-danger">*</span>
            </label>
            <div className="col-md-8">
              <div className="cal-icon">
                <DatePicker
                  selected={selectedDate2}
                  onChange={handleDateChange2}
                  className="form-control datetimepicker"
                  type="date"
                  dateFormat="dd-MM-yyyy"
                />
              </div>
              {toDateError && (
                <div className="text-danger">{toDateError}</div>
              )}
            </div>
          </div>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <table className="table">
            <tbody>
              {dynamicDates.map((dateObj, index) => (
                <tr key={index}>
                  <td>
                    {dateObj.date.toLocaleDateString("en-GB")}{" "}
                    <span className="text-danger">*</span>
                  </td>
                  <td>
                    <Select
                      options={[
                        { value: "full-day", label: "Full Day" },
                        { value: "half-day", label: "Half Day" },
                      ]}
                      defaultValue={{
                        value: dateObj.type,
                        label:
                          dateObj.type === "full-day" ? "Full Day" : "Half Day",
                      }}
                      placeholder="Select"
                      className="form-select col-md-9"
                      style={{ width: "110px" }}
                      onChange={(selectedOption) =>
                        handleTypeChange(index, selectedOption)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">
              Optional Holiday <span className="text-danger">*</span>
            </label>
            <div className="col-md-8">
              <div className="onoffswitch">
                <input
                  type="checkbox"
                  checked={restrictedHoliday}
                  onChange={handleRestrictedHolidayChange}
                  className="onoffswitch-checkbox"
                  id="switch_custom01"
                  defaultChecked
                />
                <label
                  className="onoffswitch-label"
                  htmlFor="switch_custom01"
                >
                  <span className="onoffswitch-inner" />
                  <span className="onoffswitch-switch" />
                </label>
              </div>
            </div>
          </div>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">Description</label>
            <div className="col-md-8">
              <textarea
                rows={4}
                className="form-control"
                value={description}
                onChange={handleDescriptionChange}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          Save
        </button>

        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Close
        </button>
      </div>
      <div style={{ display: "none" }}>
        <button
          ref={submitButtonRef}
          data-bs-dismiss="modal"
          aria-label="Close"
          type="reset"
        >
          Submit2
        </button>
      </div>
    </div>
  </div>
</div>

  
   {/* Edit Holiday Modal */}
<div
  id="edit_holiday"
  className="modal custom-modal fade"
  role="dialog"
>
  <div
    className="modal-dialog modal-lg"
    style={{
      margin: 0,
      position: "fixed",
      right: 0,
      height: "100vh",
      width: "40%",
    }}
    role="document"
  >
    <div className="modal-content h-100">
      <div className="modal-header">
        <h5 className="modal-title">Edit Holiday</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        className="modal-body"
        style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
      >
        <div className="scrollable-container">
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">
              Holiday Name <span className="text-danger">*</span>
            </label>
            <div className="col-md-8">
              <input
                className="form-control"
                type="text"
                value={editHolidayName}
                onChange={handleEditHolidayNameChange}
              />
              {editHolidayNameError && (
                <div className="text-danger">{editHolidayNameError}</div>
              )}
            </div>
          </div>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">
              From <span className="text-danger">*</span>
            </label>
            <div className="col-md-8">
              <div className="cal-icon">
                <DatePicker
                  selected={editSelectedDate1}
                  onChange={handleEditDateChange1}
                  className="form-control datetimepicker"
                  type="date"
                  dateFormat="dd-MM-yyyy"
                />
              </div>
              {editFromDateError && (
                <div className="text-danger">{editFromDateError}</div>
              )}
            </div>
          </div>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">
              To <span className="text-danger">*</span>
            </label>
            <div className="col-md-8">
              <div className="cal-icon">
                <DatePicker
                  selected={editSelectedDate2}
                  onChange={handleEditDateChange2}
                  className="form-control datetimepicker"
                  type="date"
                  dateFormat="dd-MM-yyyy"
                />
              </div>
              {editToDateError && (
                <div className="text-danger">{editToDateError}</div>
              )}
            </div>
          </div>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <table className="table">
            <tbody>
              {editDynamicDates.map((dateObj, index) => (
                <tr key={index}>
                  <td>
                    {dateObj.date.toLocaleDateString("en-GB")}{" "}
                    <span className="text-danger">*</span>
                  </td>
                  <td>
                    <Select
                      options={[
                        { value: "full-day", label: "Full Day" },
                        { value: "half-day", label: "Half Day" },
                      ]}
                      defaultValue={{
                        value: dateObj.type,
                        label:
                          dateObj.type === "full-day" ? "Full Day" : "Half Day",
                      }}
                      placeholder="Select"
                      className="form-select col-md-9"
                      style={{ width: "110px" }}
                      onChange={(selectedOption) =>
                        handleEditTypeChange(index, selectedOption)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">
              Optional Holiday <span className="text-danger">*</span>
            </label>
            <div className="col-md-8">
              <div className="onoffswitch">
                <input
                  type="checkbox"
                  checked={editRestrictedHoliday}
                  onChange={handleEditRestrictedHolidayChange}
                  className="onoffswitch-checkbox"
                  id="switch_custom02"
                />
                <label
                  className="onoffswitch-label"
                  htmlFor="switch_custom02"
                >
                  <span className="onoffswitch-inner" />
                  <span className="onoffswitch-switch" />
                </label>
              </div>
            </div>
          </div>
          <hr style={{ border: "0.5px solid #ddd" }} />
          <div className="form-group row mb-3">
            <label className="col-md-4 col-form-label">Description</label>
            <div className="col-md-8">
              <textarea
                rows={4}
                className="form-control"
                value={editDescription}
                onChange={handleEditDescriptionChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={handleEditSubmit}
        >
          Save Changes
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Close
        </button>
      </div>
      <div style={{ display: "none" }}>
        <button
          ref={submitButtonRef}
          data-bs-dismiss="modal"
          aria-label="Close"
          type="reset"
        >
          Submit2
        </button>
      </div>
    </div>
  </div>
</div>

    </>
  );
};

export default AddHoliday;